import { createSlice } from '@reduxjs/toolkit'

interface PortalState {
  currentScreen: string
}

const initialState: PortalState = {
  currentScreen: '',
}

const portalSlice = createSlice({
  name: 'portal',
  initialState,
  reducers: {
    setCurrentScreen: (state, action) => {
      state.currentScreen = action.payload
    },
  },
})

export const { setCurrentScreen } = portalSlice.actions
export default portalSlice.reducer
